import app from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/functions";
import { disableNetwork } from "firebase/firestore";
import { enableNetwork } from "firebase/firestore";

const REGIAO_FUNCTIONS = "southamerica-east1";

export var DEBUG = false;
if (["localhost"].includes(window.location.hostname)) {
    // DEBUG = true;
}

// eslint-disable-next-line no-unused-vars
const configDebug = {
    //teste
    apiKey: "AIzaSyCB_YFJLFxuzUyzIDQ4Ku6hsDqXsMpt0mE",
    authDomain: "approdadanegocios.firebaseapp.com",
    projectId: "approdadanegocios",
    storageBucket: "approdadanegocios.appspot.com",
    messagingSenderId: "192791551743",
    appId: "1:192791551743:web:0ad026b31eba3ef95776ca",
    measurementId: "G-1R25Q234XN",
};
// eslint-disable-next-line no-unused-vars
const config = {
    //producao
    apiKey: "AIzaSyAcVUK5UzpaLvswwh8BlapMkd2cXsXRjLM",
    authDomain: "paeco-linkme.firebaseapp.com",
    projectId: "paeco-linkme",
    storageBucket: "paeco-linkme.appspot.com",
    messagingSenderId: "518652918714",
    appId: "1:518652918714:web:7479fc23b2c5c19e83bb83",
    measurementId: "G-VJD82W2XJH",
};
let useConfigFirebaseAux = config;

if (DEBUG) {
    //debug hosts1
    useConfigFirebaseAux = configDebug;
}

export const useConfigFirebase = useConfigFirebaseAux;

class FirebaseUtil {
    constructor() {
        this.networkDisabled = false;
        app.initializeApp(useConfigFirebase);
        this.currentUser = null;
        this.auth = app.auth();
        this.functions = app.app().functions(REGIAO_FUNCTIONS);

        this.db = app.firestore();

        this.db.settings({
            cacheSizeBytes: app.firestore.CACHE_SIZE_UNLIMITED,
        });

        this.db.enablePersistence({ synchronizeTabs: true }).catch(function (err) {
            console.log("Erro ao ativar persistencia offline: ", err);
            if (err.code === "failed-precondition") {
                // Multiple tabs open, persistence can only be enabled
                // in one tab at a a time.
                // ...
            } else if (err.code === "unimplemented") {
                // The current browser does not support all of the
                // features required to enable persistence
                // ...
            }
        });
        if (window.cordova) {
            //this.disableNetwork()
        }
    }

    firestore() {
        return app.firestore;
    }

    disableNetwork() {
        disableNetwork(this.db).then(() => {
            console.log("Network disabled!");
            this.networkDisabled = true;
        });
    }
    enableNetwork() {
        enableNetwork(this.db).then(() => {
            console.log("Network enabled!");
            this.networkDisabled = false;
        });
    }

    login(email, password) {
        return this.auth.signInWithEmailAndPassword(email, password);
    }

    sendPasswordResetEmail(email) {
        return this.auth.sendPasswordResetEmail(email);
    }

    resetarSenhaUsuario(targetUid, novaSenha) {
        return this.functions.httpsCallable("resetarSenhaUsuario")({ targetUid, novaSenha });
    }

    atualizarEmailUsuario(targetUid, novoEmail) {
        return this.functions.httpsCallable("atualizarEmailUsuario")({ targetUid, novoEmail });
    }

    logout() {
        this.currentUser = null;
        return this.auth.signOut();
    }

    async registerNoLogin(email, password) {
        return new Promise((resolve, reject) => {
            let secondaryApp = app.initializeApp(useConfigFirebase, "Secondary");

            secondaryApp
                .auth()
                .createUserWithEmailAndPassword(email, password)
                .then((firebaseUser) => {
                    // console.log('firebaseUser', firebaseUser)
                    console.log("User created successfully!" /*+ firebaseUser.user.uid*/);
                    secondaryApp.auth().signOut();
                    resolve(firebaseUser);
                })
                .catch((error) => {
                    reject(error);
                });
        });
        // return this.getCurrentUser().updateProfile({ displayName: name })
    }

    async register(name, email, password) {
        await this.auth.createUserWithEmailAndPassword(email, password);
        return this.getCurrentUser().updateProfile({
            displayName: name,
        });
    }

    isInitialized(updateUser) {
        return new Promise((resolve) => {
            this.auth.onAuthStateChanged((r) => {
                this.currentUser = r;
                console.log("logado onAuthStateChanged", r);
                if (updateUser) updateUser(r);
                resolve(r);
            });
        });
    }

    getCurrentUsername() {
        return this.getCurrentUser() && this.getCurrentUser().displayName;
    }
    getCurrentUser() {
        if (this.currentUser) {
            return this.currentUser;
        }
        return this.auth.currentUser;
    }
}

export default new FirebaseUtil();
